// assets/fondo-filter.js
// Custom Fondo filter - filters products by background color extracted from title
(function () {
  if (!location.pathname.startsWith("/collections/")) return;

  function norm(s) {
    return String(s || "").trim().toLowerCase();
  }

  function extractFondoFromTitle(title) {
    const parts = title.split(" - ");
    if (parts.length > 1) {
      const fondo = norm(parts[parts.length - 1]);
      if (fondo === "blanco" || fondo === "espejo") {
        return fondo;
      }
    }
    return null;
  }

  function getSelectedFondos() {
    const checkboxes = document.querySelectorAll('[data-fondo-filter]:checked');
    return Array.from(checkboxes).map(cb => norm(cb.value));
  }
  
  // Force visual checkmark update - applies directly to DOM
  function forceCheckmarkVisual(targetCheckbox = null) {
    const checkboxes = targetCheckbox ? [targetCheckbox] : document.querySelectorAll('[data-fondo-filter]');
    
    checkboxes.forEach(checkbox => {
      const checkboxDiv = checkbox.closest('.checkbox');
      const label = checkboxDiv?.querySelector('.checkbox__label');
      const icon = label?.querySelector('.icon-checkmark');
      
      if (!icon) return;

      const computedStyle = getComputedStyle(document.documentElement);
      const foreground = computedStyle.getPropertyValue('--color-foreground').trim();
      const background = computedStyle.getPropertyValue('--color-background').trim();
      
      if (checkbox.checked) {
        // SVG container - also set CSS variable for path opacity
        icon.style.setProperty('--checkbox-path-opacity', '1', 'important');
        icon.style.setProperty('background-color', foreground, 'important');
        icon.style.setProperty('border-color', foreground, 'important');
        icon.style.setProperty('display', 'inline-block', 'important');
        icon.style.setProperty('width', '1.25rem', 'important');
        icon.style.setProperty('height', '1.25rem', 'important');
        
        // Path (checkmark)
        const path = icon.querySelector('path');
        if (path) {
          path.style.setProperty('opacity', '1', 'important');
          path.style.setProperty('stroke', background, 'important');
          path.style.setProperty('stroke-width', '2.5', 'important');
          path.style.setProperty('fill', 'none', 'important');
        }
      } else {
        // Unchecked state - also set CSS variable to 0
        icon.style.setProperty('--checkbox-path-opacity', '0', 'important');
        icon.style.setProperty('background-color', background, 'important');
        icon.style.setProperty('border-color', 'currentColor', 'important');
        const path = icon.querySelector('path');
        if (path) {
          path.style.setProperty('opacity', '0', 'important');
        }
      }
    });
  }

  function filterProducts() {
    const selectedFondos = getSelectedFondos();
    
    // If no fondo selected, show all products
    if (selectedFondos.length === 0) {
      document.querySelectorAll('.product-grid__item').forEach(card => {
        card.style.display = '';
        card.style.opacity = '1';
      });
      updateProductCount();
      return;
    }

    // Filter products based on selected fondos
    document.querySelectorAll('.product-grid__item').forEach(card => {
      const titleEl = card.querySelector('.product-card__title, .product-title, h3, h4, [class*="title"]');
      
      if (!titleEl) {
        card.style.display = 'none';
        return;
      }

      const productTitle = titleEl.textContent || titleEl.innerText || '';
      const productFondo = extractFondoFromTitle(productTitle);

      if (productFondo && selectedFondos.includes(productFondo)) {
        card.style.display = '';
        card.style.opacity = '1';
      } else {
        card.style.display = 'none';
        card.style.opacity = '0';
      }
    });

    // Update product count
    updateProductCount();
  }
  
  // Make filterProducts globally accessible for inline onchange handlers
  window.filterProducts = filterProducts;

  function updateProductCount() {
    const visibleProducts = document.querySelectorAll('.product-grid__item:not([style*="display: none"])').length;
    const countElements = document.querySelectorAll('.products-count-wrapper span');
    
    countElements.forEach(el => {
      // Try to get the translation pattern
      const currentText = el.textContent;
      const match = currentText.match(/(\d+)/);
      if (match) {
        el.textContent = currentText.replace(match[1], visibleProducts);
      }
    });
  }

  function updateURLWithFondo() {
    const selectedFondos = getSelectedFondos();
    const url = new URL(window.location);
    
    if (selectedFondos.length > 0) {
      // Add fondo parameter to URL
      url.searchParams.set('fondo', selectedFondos.join(','));
    } else {
      // Remove fondo parameter if nothing selected
      url.searchParams.delete('fondo');
    }
    
    // Update URL without reloading page
    window.history.pushState({}, '', url);
  }

  function initFromURL() {
    // Check if there's a fondo parameter in URL
    const url = new URL(window.location);
    const fondoParam = url.searchParams.get('fondo');
    
    if (fondoParam) {
      const fondos = fondoParam.split(',').map(f => norm(f));
      // Check the appropriate checkboxes
      document.querySelectorAll('[data-fondo-filter]').forEach(checkbox => {
        const checkboxValue = norm(checkbox.value);
        if (fondos.includes(checkboxValue)) {
          checkbox.checked = true;
        }
      });
    }
  }

  function initFondoFilter() {
    // Initialize from URL parameters
    initFromURL();
    
    // Listen to all fondo filter checkboxes
    document.addEventListener('change', (e) => {
      if (e.target.matches('[data-fondo-filter]')) {
        const changedValue = e.target.getAttribute('data-fondo-filter');
        const isChecked = e.target.checked;
        
        // Update ALL checkboxes with the same data-fondo-filter value (desktop + mobile)
        document.querySelectorAll(`[data-fondo-filter="${changedValue}"]`).forEach(checkbox => {
          if (checkbox !== e.target) {
            checkbox.checked = isChecked;
          }
          // Apply visual styles to each checkbox (desktop + mobile)
          forceCheckmarkVisual(checkbox);
        });
        
        filterProducts();
        updateURLWithFondo();
      }
    });

    // Also listen for form resets
    document.addEventListener('click', (e) => {
      if (e.target.closest('[href*="filter"]') || 
          e.target.closest('.facets__reset') ||
          e.target.closest('[data-clear-all]')) {
        setTimeout(() => {
          filterProducts();
          updateURLWithFondo();
        }, 100);
      }
    });

    // Watch for new products being added (pagination/infinite scroll)
    const observer = new MutationObserver((mutations) => {
      let hasNewProducts = false;
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            if (node.matches && (node.matches('.product-grid__item') || 
                node.querySelector && node.querySelector('.product-grid__item'))) {
              hasNewProducts = true;
            }
          }
        });
      });
      if (hasNewProducts) {
        setTimeout(filterProducts, 100);
      }
    });

    // Observe the product grid for changes
    const productGrid = document.querySelector('.product-grid, [class*="product-grid"]');
    if (productGrid) {
      observer.observe(productGrid, {
        childList: true,
        subtree: true
      });
    }

    // Initial filter on page load
    setTimeout(filterProducts, 200);
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFondoFilter);
  } else {
    initFondoFilter();
  }
})();
